export default __webpack_public_path__ + "static/media/sortingphhone.7773e574.png";